import { render, staticRenderFns } from "./garden30.vue?vue&type=template&id=398be8c0&scoped=true"
import script from "./garden30.vue?vue&type=script&lang=js"
export * from "./garden30.vue?vue&type=script&lang=js"
import style0 from "./garden30.vue?vue&type=style&index=0&id=398be8c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "398be8c0",
  null
  
)

export default component.exports